// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as enums from '@trialcard/enums';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';


export enum TCApiGatewayControllersModelsScheduleEventType {
    NUMBER_66 = 66,
    NUMBER_72 = 72,
    NUMBER_78 = 78,
    NUMBER_79 = 79,
    NUMBER_82 = 82,
    NUMBER_83 = 83,
    NUMBER_84 = 84
}
